import React from 'react'
import { useHistory } from 'react-router-dom'

import { greyMultibrandPalette } from '@masfront/common-b2c'

import { Typography, Box, makeStyles, Link } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import { useBrand } from '~/brand'
import { Action } from '~/ui/components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(10, 6),
    backgroundColor: theme.palette.common.white,
    borderBottom: `${greyMultibrandPalette[100]} 2px solid`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  backIcon: {
    paddingRight: theme.spacing(6),
  },
}))

export interface Action {
  icon?: React.ReactElement
  label?: string
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
}

export interface MainTitleHeaderProps {
  title: React.ReactNode
  subtitle?: string
  actions?: Action[]
  goBackUrl?: string
}

export const MainTitleHeader: React.FC<MainTitleHeaderProps> = ({
  title,
  subtitle,
  actions,
  goBackUrl,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const { brand } = useBrand()

  return (
    <div className={classes.root} data-hook="main-title-header">
      <Box width="100%">
        <Box display="flex" alignItems="start" justifyContent="space-between">
          <Box display="flex">
            {goBackUrl && (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <Link
                className={classes.backIcon}
                component="button"
                onClick={() => history.push({ pathname: goBackUrl, search: `?brand=${brand}` })}
              >
                <ArrowBackIcon />
              </Link>
            )}
            <Typography variant="h2" component={Box}>
              {title}
            </Typography>
          </Box>
          {actions &&
            actions.map((action) => (
              <Action
                icon={action.icon}
                key={`${action.label}`}
                label={action.label}
                onClick={action.onClick}
                disabled={action.disabled}
                isLoading={action.isLoading}
              />
            ))}
        </Box>
        {subtitle && (
          <Box pl={13}>
            <Typography variant="h5">{subtitle}</Typography>
          </Box>
        )}
      </Box>
    </div>
  )
}
